import { memo, useEffect, useRef, useState } from "react";

import { useTopGroups } from "GroupsManagement/hooks/useNavBarGroups";

import { useDebouncedSearchValue } from "../groupsCommunicationStore";

import RecursiveGroups from "./RecursiveGroups";

const NetworkGroups = memo(() => {
  const { topGroups } = useTopGroups();
  const debouncedSearchValue = useDebouncedSearchValue();
  const [timerResetTrigger, setTimerResetTrigger] = useState({});
  const timerRef = useRef(0);
  const hasRenderedWithDataRef = useRef(false);

  const isFirstDataLoad =
    !hasRenderedWithDataRef.current && topGroups.length > 0;
  if (isFirstDataLoad) hasRenderedWithDataRef.current = true;

  useEffect(() => {
    timerRef.current = 0;
    setTimerResetTrigger({});
  }, [debouncedSearchValue]);

  return topGroups.map((group) => (
    <RecursiveGroups
      timerRef={timerRef}
      timerResetTrigger={timerResetTrigger}
      isInitialLoad={isFirstDataLoad}
      key={group.ID}
      {...group}
    />
  ));
});

export default NetworkGroups;
